import type { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import type { IActionableReportState } from '@/store/modules/report/actionable-report/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const actionableReportModule: Module<IActionableReportState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
